'use client';

import { motion } from 'motion/react';

import { cn } from '@/lib/utils';

import { useSim } from './use-sim';

/**
 * The audit that forced the watchdog, drawn cell by cell: 226 attempts the
 * engine declared dead in one week; 165 of them ink in because they had
 * already finished at the provider.
 */

const TOTAL = 226;
const FINISHED = 165;
const CELLS = Array.from({ length: TOTAL }, (_, i) => i);

export function WatchdogWaffle() {
  const { ref, tick, reduceMotion } = useSim({
    totalTicks: 2,
    msPerTick: 1400,
  });
  const inked = reduceMotion || tick >= 1;

  return (
    <div ref={ref} className="mt-4 border border-edge bg-muted/20 p-4">
      <div
        className="grid gap-[3px]"
        style={{ gridTemplateColumns: 'repeat(24, minmax(0, 1fr))' }}
        role="img"
        aria-label="Of 226 attempts declared timed out in one week, 165 had already finished at the provider."
      >
        {CELLS.map((i) => {
          const finished = i < FINISHED;
          return (
            <motion.span
              key={i}
              aria-hidden
              initial={false}
              animate={{
                opacity: inked && finished ? 1 : 0.3,
              }}
              transition={{
                duration: 0.3,
                delay: reduceMotion ? 0 : (finished ? i : 0) * 0.006,
              }}
              className={cn(
                'aspect-square w-full',
                inked && finished ? 'bg-foreground' : 'bg-muted-foreground'
              )}
            />
          );
        })}
      </div>

      <div className="mt-3 flex flex-wrap items-baseline gap-x-5 gap-y-1 font-mono text-[11px] text-muted-foreground tabular-nums">
        <span>
          <b className="text-base font-semibold text-foreground">226</b>{' '}
          declared dead in one week
        </span>
        <span>
          <b className="text-base font-semibold text-foreground">
            {inked ? 165 : '…'}
          </b>{' '}
          had already finished
        </span>
        <span>
          <b className="text-base font-semibold text-foreground">36</b> users
          told "failed" while the file existed
        </span>
      </div>
    </div>
  );
}
